import React, { useContext, useEffect, useMemo, useState } from "react";
import { StyledCardsList, StyledHeader, StyledPlansContainer } from "./plans.style";
import PlanCard from "./PlanCard.component";
import Spinner from "../utils/LoadingSpinner";
import ProgressBarNotification from "../dashboard/notifications/progressBar/ProgressBarNotification";
import CouponInput from "./CouponInput";
import StateContext from "../../context/StateContext";
import usePlanUsage from "../../customHooks/usePlanUsage";
import * as genNotifications from "../dashboard/notifications/generateNotificationContent";
import * as shouldNotify from "../dashboard/notifications/shouldDisplayNotification";

/**
 * apply coupon discount to plan list
 * @param {*} coupon - coupon data
 * @param {*} plansList - list of plans to iterate over
 * @return {Array} plansList with updated prices
 */
const applyCouponToPlans = (coupon, plansList) => {
	if (Array.isArray(plansList)) {
		const newPlansList = [];
		plansList.forEach((plan, index) => {
			newPlansList[index] = { ...plan };
			if (coupon.amount_off) {
				newPlansList[index].price = plan.price - coupon.amount_off;
				newPlansList[index].originalPrice = plan.price;
			} else if (coupon.percent_off) {
				newPlansList[index].price = plan.price - plan.price * (coupon.percent_off / 100);
				newPlansList[index].originalPrice = plan.price;
			}
		});
		return [...newPlansList];
	} else return [...plansList];
};

const SubscribePlan = () => {

	const { plans, plansList } = useContext(StateContext);
	const [plansToSubscribe, setPlansToSubscribe] = useState(plansList);
	const [applyCoupon, setApplyCoupon] = useState(false);
	const [showSpinner, setShowSpinner] = useState(false);
	const [coupon, setCoupon] = useState("");
	const [couponObj, setCouponObj] = useState(null);
	const totalSessions = usePlanUsage();

	const activePlan = useMemo(() => plans.find((plan) => plan?.state.toLowerCase() === "active"), [plans]);
	const planSessions = useMemo(() => totalSessions && totalSessions[activePlan?.plan_id], [activePlan?.plan_id, totalSessions]);

	useEffect(() => {
		if (applyCoupon) {
			setPlansToSubscribe(applyCouponToPlans(couponObj, plansList));
		}
	}, [applyCoupon, couponObj, plansList]);

	const renderCards = () => {
		if (plansToSubscribe.length) {
			return plansToSubscribe.map((plan) => {
				return (
					<li key={plan.id}>
						<PlanCard activePlan={activePlan} plan={plan} setShowSpinner={setShowSpinner} applyCoupon={applyCoupon} coupon={coupon} />
					</li>
				);
			});
		}
	};

	return (
		<StyledPlansContainer>
			<StyledHeader>
				<h2>Grow Your Business with Fixel</h2>
				<p>Choose the plan that fit your business goals</p>
			</StyledHeader>
			{/* notifications */}
			<ProgressBarNotification show={shouldNotify.showPlanUsageProgressBar(activePlan)} content={genNotifications.planUsageContent(planSessions, activePlan?.max_traffic)} type="planUsage" />
			{/* plans */}
			<StyledCardsList>{showSpinner ? <Spinner /> : renderCards()}</StyledCardsList>
			{/* coupon */}
			<CouponInput setApplyCoupon={setApplyCoupon} applyCoupon={applyCoupon} coupon={coupon} setCoupon={setCoupon} setCouponObj={setCouponObj} />
		</StyledPlansContainer>
	);
};
export default SubscribePlan;
